/* eslint-disable import/prefer-default-export */
import styled from "styled-components"

export const FullWidthForm = styled.form`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.dark[5]};
  padding: ${({ theme }) => theme.space[3]}px;
`
